import { render } from "./OrderTheLetters.vue?vue&type=template&id=6f528a2e&scoped=true"
import script from "./OrderTheLetters.vue?vue&type=script&lang=js"
export * from "./OrderTheLetters.vue?vue&type=script&lang=js"

import "./OrderTheLetters.vue?vue&type=style&index=0&id=6f528a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f528a2e"]])

export default __exports__